// Utility functions for Task Management

// Date formatting
export const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-GB', { 
        day: '2-digit', 
        month: '2-digit', 
        year: 'numeric' 
    });
};

export const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', { 
        day: '2-digit', 
        month: '2-digit', 
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
};

// Priority color mapping
export const getPriorityColor = (priority) => {
    const colors = { 
        low: '#10b981', 
        medium: '#f59e0b', 
        high: '#ef4444', 
        urgent: '#dc2626' 
    };
    return colors[priority] || '#6b7280';
};

// Status badge configuration
export const getStatusBadge = (status) => {
    const badges = {
        'todo': { label: 'To Do', class: 'status-todo' },
        'in-progress': { label: 'In Progress', class: 'status-in-progress' },
        'review': { label: 'Review', class: 'status-review' },
        'completed': { label: 'Completed', class: 'status-completed' }
    };
    return badges[status] || { label: status, class: '' };
};

// Approval status badge configuration
export const getApprovalStatusBadge = (approvalStatus) => {
    const badges = {
        'pending': { label: 'Pending', class: 'approval-pending' },
        'approved': { label: 'Approved', class: 'approval-approved' },
        'rejected': { label: 'Rejected', class: 'approval-rejected' }
    };
    return badges[approvalStatus] || { label: approvalStatus, class: '' };
};

// Check if task is overdue
export const isOverdue = (dueDate, status) => {
    return status !== 'completed' && new Date(dueDate) < new Date();
};

// Get tab title based on active tab, approval permission and visibility scope
export const getTabTitle = (activeTab, isManager, scope) => {
    if (activeTab === 'assigned-to-me') {
        return isManager ? 'Approval Requests' : 'Tasks Assigned to Me';
    }
    if (activeTab === 'assigned-by-me') return 'Tasks I Assigned';
    return scope === 'department' ? 'Tasks in My Department' : 'All Tasks';
};

// Filter users based on search term
export const filterUsers = (users, searchTerm) => {
    if (!searchTerm.trim()) return users;
    
    const searchLower = searchTerm.toLowerCase();
    const filtered = {};
    
    Object.keys(users).forEach(department => {
        const filteredDeptUsers = users[department].filter(u => 
            u.fullName.toLowerCase().includes(searchLower) ||
            u.role.toLowerCase().includes(searchLower) ||
            department.toLowerCase().includes(searchLower)
        );
        if (filteredDeptUsers.length > 0) {
            filtered[department] = filteredDeptUsers;
        }
    });
    
    return filtered;
};

// Get all user IDs from users object
export const getAllUserIds = (users) => {
    return Object.values(users).flat().map(u => u._id);
};
